import { Plus } from 'lucide-react';
import { useState } from 'react';
import type { PropertyResponse } from '@/shared/api';
import { canManage, useAuth } from '@/shared/auth';
import { Button } from '@/shared/components';
import { ManualBookingPanel } from '@/features/properties/manual-booking';

/**
 * „+ Manuelle Buchung“ aus der Liste: dasselbe Panel wie Kalender und Apartmentseite, nur mit
 * Apartment-Auswahl. Wählbar ist, was auch die Apartmentseite anbietet: aktiv und mit dem
 * Kanalmanager verbunden – der Server nimmt pausierte, archivierte und Entwürfe nicht an.
 */
export function NewManualBookingButton({
  properties,
  status,
}: {
  properties: PropertyResponse[];
  /** Stand der Apartmentliste; ohne sie gibt es nichts zu wählen. */
  status: 'loading' | 'error' | 'ready';
}) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!canManage(user)) return null;
  const choices = properties.filter((p) => p.status === 'Active' && p.channexPropertyId);
  return (
    <>
      <Button
        variant="brand"
        leftIcon={<Plus size={16} aria-hidden />}
        onClick={() => setOpen(true)}
        loading={status === 'loading'}
        disabled={status !== 'ready' || choices.length === 0}
      >
        Manuelle Buchung
      </Button>
      {status === 'ready' && choices.length === 0 && (
        <span className="text-ink-soft px-2 text-xs">Kein aktives, verbundenes Apartment</span>
      )}
      <ManualBookingPanel open={open} onOpenChange={setOpen} apartment={{ choices }} />
    </>
  );
}
